import React, { useEffect } from "react";
import { MDBDataTableV5 } from "mdbreact";
import { naira } from "../../../utils/data";
import { Button, TableContainer } from "../../../styles";
import { ICON_PLUS } from "../../../utils/icons";
import MiniLoader from "../../../utils/MIniLoader";
import { usePackagesContext } from "../../../context/packages_context";
import CustomTable from "../../../utils/CustomTable";

export default function BillingReport() {


      const {
            billingHistoryLoading, getBillingHistoryData, allBillingHistory
      } = usePackagesContext();



      useEffect(() => {
            const billing = allBillingHistory?.map(({ id, active, amount_th, duration_days, expire_date, time_date, package_name }, i) => {

                  const trxId = { invtid: id };

                  return (
                        {
                              sn: i + 1, expire_date, time_date, package_name,
                              active: `${ active == '0' ? 'expired' : 'active' }`,
                              amount_th: <span className="red-text"> {naira}{amount_th} </span>,
                              duration_days: <span> {duration_days} days  </span>,
                        }
                  );
            });

            setDatatable({
                  ...datatable,

                  rows:
                        billing
            });
      }, [allBillingHistory]);

      useEffect(() => {
            getBillingHistoryData();
      }, []);


      const [datatable, setDatatable] = React.useState({
            columns: [
                  {
                        label: "S/N",
                        field: "sn",
                        width: 150,
                        attributes: {
                              "aria-controls": "DataTable",
                              "aria-label": "sn",
                        },
                  },
                  {
                        label: "Package",
                        field: "package_name",
                        width: 200,
                  },
                  {
                        label: "Amount",
                        field: "amount_th",
                        width: 270,
                  },
                  {
                        label: "Date ",
                        field: "time_date",
                        width: 200,
                  },
                  {
                        label: "Expiry ",
                        field: "expire_date",
                        width: 200,
                  },
                  {
                        label: "Status ",
                        field: "active",
                        width: 200,
                  },
                  {
                        label: "Duration ",
                        field: "duration_days",
                        width: 200,
                  },

            ],
            rows: []
      });


      return (
            <>

                  <div className="">

                        <CustomTable
                              tableTitle={"Billing Report"}
                              loading={billingHistoryLoading}
                              getData={getBillingHistoryData}
                              datatable={datatable}
                        />

                  </div>

            </>

      );
}
